/** biome-ignore-all lint/suspicious/noExplicitAny: OK */

import { type ClassValue, clsx } from 'clsx';
import { camelCase } from 'lodash';
import { twMerge } from 'tailwind-merge';
import { MAX_PAGE_ID, MIN_PAGE_ID } from '@/shared/constants/constants';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toCamelCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(toCamelCase);
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = camelCase(key);
      acc[camelKey] = toCamelCase(obj[key]);
      return acc;
    }, {} as any);
  }
  return obj;
}

export function isPageIdValid(pageId: string) {
  return parseInt(pageId) >= MIN_PAGE_ID && parseInt(pageId) <= MAX_PAGE_ID;
}
